let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3L1Ns")).then(() => parcelRequire('fblEC'));